import React from "react";
import {Typography} from "@mui/material";

import {buildHealthIndicatorIcon, buildSessionHealthColor} from "../../../helpers/HealthIndicatorBuilder";
import {CenteredBox, ColoredAvatar} from "../../themes/styled";

export default function ZoomLicenseHealth({session, state}) {

    const backgroundColor = buildSessionHealthColor[state];
    const icon = buildHealthIndicatorIcon("check-zoom-license");

    return (
      <CenteredBox>
          <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
          <Typography variant="body2">Zoom License Added</Typography>
      </CenteredBox>
    );
}